import React, { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const NAV_ITEMS = [
  { to: '/lab-philosophy', label: 'Lab Philosophy' },
  { to: '/people', label: 'People' },
  { to: '/patient-partners', label: 'Patient Partners' },
  { to: '/participate', label: 'Participate' },
  { to: '/publications', label: 'Publications' },
  { to: '/news', label: 'News' },
  { to: '/awards', label: 'Awards' },
  { to: '/contact', label: 'Contact' },
];

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Close the mobile menu whenever the route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  return (
    <header className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand" onClick={() => setIsOpen(false)}>
          <span className="navbar-brand-main">Kidney ReACH & ReACH Initiatives</span>
        </Link>

        <button
          className={`navbar-toggle ${isOpen ? 'is-open' : ''}`}
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`navbar-menu ${isOpen ? 'is-open' : ''}`}>
          <Link
            to="/#donate"
            className="navbar-donate"
            onClick={() => setIsOpen(false)}
          >
            Donate
          </Link>
          <ul className="navbar-links">
            {NAV_ITEMS.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    `navbar-link ${isActive ? 'is-active' : ''}`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
